import { render, staticRenderFns } from "./DeviceDetectResult.vue?vue&type=template&id=7618d31d&scoped=true&"
import script from "./DeviceDetectResult.vue?vue&type=script&lang=js&"
export * from "./DeviceDetectResult.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetectResult.vue?vue&type=style&index=0&id=7618d31d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7618d31d",
  null
  
)

export default component.exports